<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<lib-header [title]="title"  [listMenuItems]="listMenuItems" [profile]="profile" (onItemMenuClick)="onMenuItemClick($event)"
  (onTitleClick)="onTitleClick()"></lib-header>
